import {client} from '../helpers/api';

export async function getHelpVideo() {
  const response = await client.get('/api/help-video');

  if (response.data?.status) {
    return response.data?.videos.map(
      ({
        video_id: id,
        video_url: url,
        video_title: title,
        video_description: description,
      }) => ({
        id,
        url,
        title,
        description,
      }),
    );
  } else if (response.data?.status === false) {
    throw response.data?.message || '';
  }
  throw response;
}

// {
//   status: true,
//   videos: [
//     {
//       video_id: 'afaa51e1-3b7b-44f7-8048-d56e93406ce3',
//       video_url: 'https://youtube.com/watch?v=nXCaHUe6NtE',
//       video_title: 'Test Video',
//       date_created: '2021-02-17T05:19:00.000Z',
//       date_modified: '2021-02-17T05:19:00.000Z',
//       is_deleted: 0,
//     },
//   ],
// }
